import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import Auth from './views/Auth.vue'
import AuthLogin from './components/AuthLogin.vue'
import AuthRegister from './components/AuthRegister.vue'
import AuthResetPassword from './components/AuthResetPassword.vue'
import AuthResetPasswordChangePassword from './components/AuthResetPasswordChangePassword.vue'
import AuthTermsAndConditions from './components/AuthTermsAndConditions.vue'
import Account from './views/Account.vue'
import AccountMyAccount from './components/AccountMyAccount.vue'
import AccountAccounts from './components/AccountAccounts.vue'
import AccountDigitalAssets from './components/AccountDigitalAssets.vue'
import AccountBranding from './components/AccountBranding.vue'
import Explorer from './views/Explorer.vue'

Vue.use(VueRouter);
Vue.use(Meta);

const routes = [
    {
        name: 'auth',
        path: '/auth',
        redirect: {name: 'login'},
        component: Auth,
        children: [
            {
                name: 'login',
                path: 'login',
                component: AuthLogin
            },
            {
                name: 'register',
                path: 'register',
                component: AuthRegister
            },
            {
                name: 'reset-password',
                path: 'reset-password',
                component: AuthResetPassword,
            },
            {
                name: 'change-password',
                path: 'change-password/:reset_password_token',
                component: AuthResetPasswordChangePassword
            },
            {
                name: 'terms-and-conditions',
                path: 'terms-and-conditions',
                component: AuthTermsAndConditions
            }
          ]
    },
    {
        name: 'account',
        path: '/account',
        redirect: {name: 'my-account'},
        component: Account,
        children: [
            {
                name: 'my-account',
                path: 'my-account',
                component: AccountMyAccount
            },
            {
                name: 'accounts',
                path: 'accounts',
                component: AccountAccounts
            },
            {
                name: 'digital-assets',
                path: 'digital-assets',
                component: AccountDigitalAssets
            },
            {
                name: 'branding',
                path: 'branding',
                component: AccountBranding
            }
          ]
    },
    {
        name: 'explorer',
        path: '/',
        component: Explorer,
        children: [
            {
                name: 'directory',
                path: '/:directory',
                component: Explorer,
            },
            {
                name: 'search',
                path: '/search:search_value',
                component: Explorer,
            }
        ]
    }
]

export default new VueRouter({
    mode: 'history',
    routes
})
